import {
  type ClientsMaintainerFilters,
  type DocumentsFilters,
  type FilterGroupState,
  type GlobalsFilters,
  type OperationFilters,
  type SaleAndPurchaseFilters,
  type SalesFilters,
} from './types';

const initialGlobalFilters: GlobalsFilters = {
  client: undefined,
  debtor: undefined,
  fromDate: undefined,
  toDate: undefined,
  option: undefined,
  executiveEmail: undefined,
  folio: undefined,
};

const initialSalesAndPurchasesFilters: SaleAndPurchaseFilters = {
  debtor: undefined,
  factoring: undefined,
};

const initialSalesFilters: SalesFilters = {
  purchasable: false,
  debtorName: undefined,
  debtorRut: undefined,
};
const initialQuotesFilters = {
  states: [],
};

const initialOperationsFilters: OperationFilters = {
  status: [],
  approvals: [],
  guideNumber: undefined,
  operationNumber: undefined,
};

const initialDocumentsFilters: DocumentsFilters = {
  states: [],
  siiStatuses: [],
};

const initialClientsMaintainerFilters: ClientsMaintainerFilters = {
  search: '',
};

const initialFilters: FilterGroupState = {
  globals: Object.assign(initialGlobalFilters, {}),
  salesAndPurchases: Object.assign(initialSalesAndPurchasesFilters, {}),
  sales: Object.assign({}, initialSalesFilters),
  quotes: Object.assign({}, initialQuotesFilters),
  operations: Object.assign({}, initialOperationsFilters),
  documents: Object.assign({}, initialDocumentsFilters),
  clients: Object.assign(initialClientsMaintainerFilters, {}),
  version: 'v1.1.6',
};

export {
  initialClientsMaintainerFilters,
  initialDocumentsFilters,
  initialFilters,
  initialGlobalFilters,
  initialOperationsFilters,
  initialQuotesFilters,
  initialSalesAndPurchasesFilters,
  initialSalesFilters,
};
